import React, { Component } from 'react';
import { Form, Input, Checkbox } from 'antd';

class FormItem extends Component {
    render() {
        const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = this.props.form;
        const errorBoolean = isFieldTouched(this.props.name) && getFieldError(this.props.name);

        if (this.props.type == 'checkbox') {
            return (
                <Form.Item label={ this.props.label }>
                    <Checkbox session={ this.props.session } onChange={ this.props.onChange }
                              checked={ this.props.checked }
                              disabled={ this.props.disabled !== undefined ? this.props.disabled : false }/>
                </Form.Item>
            );
        } else {
            return (
                <Form.Item validateStatus={ errorBoolean ? 'Please enter a ' + this.props.item : '' }
                           label={ this.props.label }>
                    { getFieldDecorator(this.props.name, {
                        rules: [{
                            type: this.props.type,
                            required: this.props.required,
                            message: 'Please input a valid ' + this.props.item
                        }],
                    })(
                        <Input placeholder={ this.props.placeholder } maxLength={ this.props.maxLength }
                               disabled={ this.props.disabled !== undefined ? this.props.disabled : false }/>
                    ) }
                </Form.Item>
            );
        }
    }
}

export default FormItem;
